import React from "react";
import ReactHtmlParser from "html-react-parser";
import icons from "../icons/timeline";
import card1 from "../extensions/images/redesign/how/card-1.svg";
import card2 from "../extensions/images/redesign/how/card-2.svg";
import card3 from "../extensions/images/redesign/how/card-3.svg";

const singlePrizeData = {
  title: "Win the £4 million Surrey Dream Home",
  subtitles: [
    "Buy Dream Home Draw tickets before midnight May 31 to also win your £70,000 Dream Car. Or take the cash. Tax-free.",
  ],
  charity: {
    title: "Support Your Chosen Charity At Checkout",
    subtitles: [
      "Choose from one of over 15 UK charities to donate 10% of your purchase to. It's time to Dream Big and Do Good.",
    ],
  },
  stepper: {
    vertical: {
      title: "Draw dates",
      subtitle:
        "Buy a ticket to win the £4m Surrey Dream Home by midnight September 30 & also be entered to win the Porsche Bonus Draw.",
      steps: [
        {
          isActive: true,
          leftText: ReactHtmlParser("Porsche Cayman 718"),
          rightText: ReactHtmlParser(
            "Closes September 30. <br/> Drawn October 7."
          ),
          badgeImage: "hour-glass",
        },
        {
          isActive: false,
          leftText: ReactHtmlParser("£4m Surrey Dream Home"),
          rightText: ReactHtmlParser(
            "Closes October 31. <br/> Drawn November 7."
          ),
          icon: icons.home,
          badgeImage: "hour-glass",
        },
        {
          isActive: false,
          leftText: ReactHtmlParser("Our Next Dream Home"),
          rightText: ReactHtmlParser("Launch date coming soon"),
          icon: icons.home,
          badgeImage: "hour-glass",
        },
      ],
    },
    horizontal: {
      title: "Draw dates",
      subtitle: ReactHtmlParser(
        "Buy a ticket to win the £4m Surrey Dream Home by midnight September 30 & also be entered to win the Porsche Bonus Draw."
      ),
      steps: [
        {
          leftText: ReactHtmlParser("Porsche Cayman 718"),
          rightText: ReactHtmlParser(
            "Closes September 30. <br/> Drawn October 7."
          ),
          icon: icons.car,
        },
        {
          leftText: ReactHtmlParser("£4m Surrey Dream Home"),
          rightText: ReactHtmlParser(
            "Closes October 31. <br/> Drawn November 7."
          ),
          icon: icons.home,
        },
        {
          leftText: ReactHtmlParser("Our Next Dream Home"),
          rightText: ReactHtmlParser("Launch date coming soon"),
          icon: icons.home,
        },
      ],
    },
  },
  ticketSelector: {
    title: "",
    subtitle:
      "Buy a ticket to win the £4m Surrey Dream Home by midnight September 30 & also be entered to win the Porsche Bonus Draw.",
  },
};
const doublePrizeData = {
  title: "Win the £4 million Surrey Dream Home",
  subtitles: [
    "Everyone's dream is different. Double your chances today of winning the cash to buy your dream home.",
    "Choose your ticket bundle below and claim 2-for-1 on those tickets at no extra cost.",
  ],
  charity: {
    title: "Support Your Chosen Charity At Checkout",
    subtitles: [
      "Choose from one of over 15 UK charities to donate 10% of your purchase to. It's time to Dream Big and Do Good.",
    ],
  },
  stepper: {
    vertical: {
      title: "Draw dates",
      subtitle:
        "Buy a ticket to win the £4m Surrey Dream Home by midnight September 30 & also be entered to win the Porsche Bonus Draw.",
      steps: [
        {
          isActive: true,
          leftText: ReactHtmlParser("Porsche Cayman 718"),
          rightText: ReactHtmlParser(
            "Closes September 30. <br/> Drawn October 7."
          ),
          badgeImage: "hour-glass",
        },
        {
          isActive: false,
          leftText: ReactHtmlParser("£4m Surrey Dream Home"),
          rightText: ReactHtmlParser(
            "Closes October 31. <br/> Drawn November 7."
          ),
          icon: icons.home,
          badgeImage: "hour-glass",
        },
        {
          isActive: false,
          leftText: ReactHtmlParser("Our Next Dream Home"),
          rightText: ReactHtmlParser("Launch date coming soon"),
          icon: icons.home,
          badgeImage: "hour-glass",
        },
      ],
    },
    horizontal: {
      title: "Draw dates",
      subtitle: ReactHtmlParser(
        "Buy a ticket to win the £4m Surrey Dream Home by midnight September 30 & also be entered to win the Porsche Bonus Draw."
      ),
      steps: [
        {
          leftText: ReactHtmlParser("Porsche Cayman 718"),
          rightText: ReactHtmlParser(
            "Closes September 30. <br/> Drawn October 7."
          ),
          icon: icons.car,
        },
        {
          leftText: ReactHtmlParser("£4m Surrey Dream Home"),
          rightText: ReactHtmlParser(
            "Closes October 31. <br/> Drawn November 7."
          ),
          icon: icons.home,
        },
        {
          leftText: ReactHtmlParser("Our Next Dream Home"),
          rightText: ReactHtmlParser("Launch date coming soon"),
          icon: icons.home,
        },
      ],
    },
  },
  ticketSelector: {
    title: "",
    subtitle:
      "Buy a ticket to win the £4m Surrey Dream Home by midnight September 30 & also be entered to win the Porsche Bonus Draw.",
  },
};

const faqs = [
  {
    title: "Our prize philosophy",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            We believe that dream homes are just as unique as you. Your dream
            home may be a countryside manor, or a sleek city penthouse. Whatever
            it is, it’s your dream home, not someone else’s. That’s why we offer
            you the chance to win the Dream Home Draw when you enter or take the
            cash alternative to buy or build your perfect home.
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "How to enter",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            Head to{" "}
            <a href={`${process.env.REACT_APP_BASE_URL}/ticket-selector`}>
              the ticket selector
            </a>{" "}
            and choose your bundle.
          </li>
          <li>
            Enter your email at checkout – we’ll create an account for you using
            this email, and you can activate it when you receive your tickets
            via email.
          </li>
          <li>
            We’ll email you a ticket receipt immediately and you can view your
            tickets online as well.
          </li>
          <li>
            You can choose to make a one-off purchase or subscribe for more
            benefits. Or enter for free via our postal entry method.
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "Free entry",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            Every single one of our Bonus Draw and Dream Home Draw competitions
            can be entered for free, via a postal entry.
          </li>
          <li>
            Find out more about the free entry{" "}
            <a href={`${process.env.REACT_APP_BASE_URL}/post`}>here</a>.
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "Subscriptions",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            Benefit from triple the usual entries by subscribing to one of our
            monthly packages and never miss a draw.
          </li>
          <li>
            Enjoy the benefits of remaining a subscriber for weekly bonuses.
          </li>
          <li>
            Find out more about our subscription packages{" "}
            <a href={`${process.env.REACT_APP_BASE_URL}/post`}>here</a>.
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "The Draw",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            The Bonus Draw and Dream Home competition draws are conducted and
            managed by Civica, our third-party draw-management partner. The
            winner is drawn on the fifth working day after the conclusion of a
            competition, which allows for the receipt of postal entries.
          </li>
          <li>
            If you enter before a Bonus Draw concludes, every Dream Home Draw
            ticket you buy will also give you the chance to win the Bonus Draw
            as well.
          </li>
          <li>
            Winners are contacted by email and phone by one of our brand
            representatives – we don’t want you to miss this life-changing
            moment, and so you have 21-days to respond to us – and we’ll keep
            trying you every day until we hear from you!
          </li>
          <li>
            In the event we don’t sell enough tickets to award the full prize,
            the winner will receive 70% of the take, net of costs. See the T&Cs
            for more information{" "}
            <a href={process.env.REACT_APP_BASE_URL + "/legal/0"}>here</a>
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "Donations",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            Every time you enter, you’ll have the chance to support one of our
            charity partners or donate to a charity that is close to your heart.
            10% of your ticket proceeds will be donated, net of costs.
          </li>
          <li>
            We make the multiple donations once a year on your behalf after a
            third-party accountant has compiled and filed our year-end accounts
            at Companies House.
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "Chat to us",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            Kathie, Agneta, and Alex from our Customer Support Team are
            available as near to 24/7 as human rights laws allow for any
            questions you may have. Click contact us from the menu or footer to
            say hi!
          </li>
        </ul>
      </React.Fragment>
    ),
  },
];

const faqsImages = [
  `${process.env.REACT_APP_AWS_S3_URL}gallery/home/TheKentDreamHome_800x600.jpg`,
  `${process.env.REACT_APP_AWS_S3_URL}gallery/home/Kitchen_800x600.jpg`,
  `${process.env.REACT_APP_AWS_S3_URL}gallery/home/DiningRoom_800x600.jpg`,
  `${process.env.REACT_APP_AWS_S3_URL}gallery/home/SittingRoom_800x600.jpg`,
  `${process.env.REACT_APP_AWS_S3_URL}gallery/home/LivingRoom_800x600.jpg`,
  `${process.env.REACT_APP_AWS_S3_URL}gallery/home/Bedrooms_800x600.jpg`,
  `${process.env.REACT_APP_AWS_S3_URL}gallery/home/Bathrooms_800x600.jpg`,
];

const howItWorksItems = [
  {
    title: "Choose your tickets",
    description:
      "Choose your tickets from our range of ticket bundles to win a home. Or, subscribe for regular monthly tickets and never miss a draw.",
    icon: card1,
  },
  {
    title: "Choose your charity",
    description:
      "Let that imagination run wild, while we sort the donation to your chosen charity. Your ticket numbers will be emailed to you, and also available to view in your account.",
    icon: card2,
  },
  {
    title: "Choose your dream home",
    description:
      "We’ll contact you if you win, then it’s decision time: move into the Dream Home you’ve always wanted, or pocket the cash alternative, tax-free.",
    icon: card3,
  },
];

const simpleGalleryData = [
  {
    title: "The Surrey Dream Home",
    text: "This £4 million Dream Home is complete with £200,000 of furnishings and you won’t pay a penny in fees or taxes.",
    imageName: `${process.env.REACT_APP_AWS_S3_URL}gallery/home/TheSurreyDreamHome`,
  },
  {
    title: "Kitchen",
    text: "The superb kitchen, breakfast, and family room overlooks and has access to the garden terrace, prefect for those alfresco summer moments",
    imageName: `${process.env.REACT_APP_AWS_S3_URL}gallery/home/Kitchen`,
  },
  {
    title: "Dining Room",
    text: "The arrangement of glazed sliding doors located in all principal living spaces enables ideal inside/outside dining, living and entertaining.",
    imageName: `${process.env.REACT_APP_AWS_S3_URL}gallery/home/DiningRoom`,
  },
  {
    title: "Sitting Room",
    text: "Relaxing never felt so good. You’ll be snuggled in pure opulence whether you’re taking in the sun with your morning coffee or putting your feet up at night.",
    imageName: `${process.env.REACT_APP_AWS_S3_URL}gallery/home/SittingRoom`,
  },
  {
    title: "Living Room",
    text: "Entertaining or just putting your feet up? With oodles of space and a beautiful, central fire feature, when the sun goes down, you’ll be toasty as can be.",
    imageName: `${process.env.REACT_APP_AWS_S3_URL}gallery/home/LivingRoom`,
  },
  {
    title: "Gym",
    text: "There’ll be no excuses not to finally maintain your New Year’s resolution with your very own personal home gym.",
    imageName: `${process.env.REACT_APP_AWS_S3_URL}gallery/home/Gym`,
  },
  {
    title: "Bedrooms",
    text: "With five in total, the principal bedroom features its own private balcony, offering an idyllic spot for a morning brew overlooking your secluded garden, accessible from both the bedrooms and the dressing room.",
    imageName: `${process.env.REACT_APP_AWS_S3_URL}gallery/home/Bedrooms`,
  },
  {
    title: "Bathrooms",
    text: "All four bathrooms are beautifully appointed, with two having access to your very own balconies. Brush your teeth with a view..",
    imageName: `${process.env.REACT_APP_AWS_S3_URL}gallery/home/Bathrooms`,
  },
  {
    title: "Terrace & Garden",
    text: "To the rear of the property there is an expansive paved terrace, with ornamental water feature, exterior lighting and steps leading to the rest of the garden, which provides expanses of terraced lawns; the setting is exceptionally tranquil, with mature woodland all around.",
    imageName: `${process.env.REACT_APP_AWS_S3_URL}gallery/home/Terrace&garden`,
  },
];

const dreamDrawAccordion = [
  {
    title: "Value",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            £4 million with not a penny of Stamp Duty to pay. Or, if you’d
            rather be an overnight millionaire, take the cash, tax-free.
          </li>
        </ul>
      </React.Fragment>
    ),
    icon: (
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.9974 1.1665C3.94745 1.1665 0.664062 4.4496 0.664062 8.49984C0.664062 12.5501 3.94745 15.8332 7.9974 15.8332C12.0473 15.8332 15.3307 12.5498 15.3307 8.49984C15.3307 4.44989 12.0473 1.1665 7.9974 1.1665ZM7.74818 7.88911H9.63193V9.4844H7.81578L7.84643 10.1739C7.84643 10.6417 7.72583 11.0092 7.48435 11.2759H11.2149V12.9325H4.65557V11.2759H5.2875C5.52068 11.2143 5.64328 11.0029 5.6556 10.6417L5.66161 10.3154L5.63096 9.48411H4.63695V7.88882H5.58198L5.54503 6.55736C5.54503 5.7189 5.79539 5.0632 6.29669 4.59083C6.79771 4.11846 7.47576 3.88213 8.33083 3.88213C9.24721 3.88213 9.96193 4.11731 10.4753 4.58768C10.9886 5.05804 11.2453 5.69627 11.2453 6.50208H9.22029C9.22029 5.85984 8.94214 5.53872 8.38583 5.53872C8.17729 5.53872 8.00943 5.6215 7.88281 5.78736C7.75591 5.95294 7.6926 6.20989 7.6926 6.55736L7.74789 7.88882L7.74818 7.88911Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    title: "Location",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            One of the most prestigious counties in the U.K.; Surrey is on
            London's doorstep though surrounded by picturesque British
            countryside.
          </li>
        </ul>
      </React.Fragment>
    ),
    icon: (
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        tabIndex="-1"
        title="Location"
      >
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"></path>
      </svg>
    ),
  },
  {
    title: "Furnishings",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            The property is yours fully furnished, complete with more than
            £200,000 of opulent and perfectly styled décor.
          </li>
        </ul>
      </React.Fragment>
    ),
    icon: (
      <svg
        width="224"
        height="240"
        viewBox="0 0 224 240"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M90.2187 20.583H19.5934V68.4722H90.2187V20.583ZM16.3121 89.0555H82.0867C82.852 86.5498 84.34 84.3661 86.3383 82.8162C88.3365 81.2661 90.7428 80.4293 93.2134 80.4251H109.516V3.5001C109.514 2.57237 109.168 1.68312 108.553 1.02712C107.938 0.37111 107.104 0.00180882 106.234 9.06699e-05H3.5782C2.70835 0.00180882 1.87465 0.37111 1.25965 1.02712C0.64471 1.68312 0.29848 2.57237 0.296875 3.5001V236.501C0.29848 237.427 0.64471 238.317 1.25965 238.973C1.87465 239.629 2.70835 239.998 3.5782 240H106.234C107.104 239.998 107.938 239.629 108.553 238.973C109.168 238.317 109.514 237.427 109.516 236.501V194.712H102.932V204.178C102.932 205.106 102.586 205.995 101.971 206.651C101.355 207.309 100.521 207.677 99.6504 207.677H96.7807V222.917C96.7807 223.845 96.435 224.734 95.8195 225.392C95.2042 226.048 94.3696 226.416 93.4995 226.416H16.3121C15.442 226.416 14.6074 226.048 13.992 225.392C13.3767 224.734 13.0309 223.845 13.0309 222.917V168.027C13.0309 167.099 13.3767 166.21 13.992 165.552C14.6074 164.896 15.442 164.528 16.3121 164.528H72.5871V160.504C68.445 158.606 65.0542 155.224 62.9997 150.944H16.3121C15.442 150.944 14.6074 150.575 13.992 149.919C13.3767 149.263 13.0309 148.372 13.0309 147.444V92.555C13.0311 91.6269 13.3768 90.7368 13.9921 90.0805C14.6076 89.4243 15.442 89.0555 16.3121 89.0555ZM13.0309 17.083C13.0309 16.1549 13.3767 15.2646 13.992 14.6082C14.6074 13.9518 15.442 13.5831 16.3121 13.5831H93.4999C94.3701 13.5831 95.2047 13.9518 95.8201 14.6082C96.4354 15.2646 96.7812 16.1549 96.7812 17.083V71.9722C96.7812 72.9003 96.4354 73.7906 95.8201 74.447C95.2047 75.1034 94.3701 75.4722 93.4999 75.4722H16.3121C15.442 75.4722 14.6074 75.1034 13.992 74.447C13.3767 73.7906 13.0309 72.9003 13.0309 71.9722V17.083ZM212.311 9.06699e-05H178.806C177.942 -0.00614301 177.102 0.309229 176.431 0.89197C175.761 1.47471 175.302 2.2884 175.132 3.19309L167.481 42.8226C167.367 43.4045 167.376 44.0062 167.506 44.5838C167.638 45.1616 167.89 45.7005 168.241 46.1614C168.594 46.6222 169.038 46.9933 169.542 47.2472C170.046 47.5013 170.596 47.632 171.154 47.6296H219.963C220.519 47.632 221.07 47.5013 221.574 47.2472C222.078 46.9933 222.522 46.6222 222.874 46.1614C223.227 45.7005 223.477 45.1616 223.609 44.5838C223.741 44.0062 223.75 43.4045 223.635 42.8226L215.985 3.19309C215.815 2.2884 215.356 1.47471 214.686 0.89197C214.015 0.309229 213.175 -0.00614301 212.311 9.06699e-05ZM202.027 139.95C202.188 141.977 202.065 144.019 201.66 146.007H220.185C220.35 146.007 220.512 145.961 220.654 145.873C220.797 145.785 220.915 145.659 220.998 145.507C221.08 145.355 221.124 145.182 221.124 145.007C221.124 144.831 221.08 144.659 220.998 144.507L218.812 140.45C218.733 140.296 218.614 140.168 218.472 140.08C218.328 139.992 218.166 139.947 218.001 139.95L202.027 139.95ZM193.099 124.355C194.982 125.622 196.644 127.226 198.016 129.095V54.6291H193.099V124.355ZM81.5182 121.262V96.055H19.5934V143.945H61.0234C60.7315 141.084 61.0071 138.189 61.8322 135.449C62.6572 132.71 64.0135 130.185 65.8126 128.041C67.6119 125.897 69.8139 124.18 72.2755 123.002C74.7373 121.825 77.4037 121.213 80.1016 121.206C80.5773 121.206 81.0504 121.225 81.5182 121.262ZM174.921 123.067V92.9002C174.916 91.4494 174.375 90.0594 173.413 89.0334C172.45 88.0077 171.148 87.4294 169.788 87.4251H93.2134C91.8532 87.4291 90.5499 88.0074 89.5881 89.0331C88.6263 90.059 88.0842 91.4493 88.0801 92.9002V123.067C91.4193 124.707 94.2493 127.33 96.2371 130.628C98.2249 133.926 99.2875 137.762 99.2997 141.683V159.062C99.3022 159.72 99.5484 160.35 99.9846 160.814C100.421 161.28 101.011 161.542 101.628 161.546H161.373C161.989 161.542 162.58 161.28 163.017 160.814C163.453 160.35 163.699 159.72 163.702 159.062V141.683C163.714 137.762 164.776 133.926 166.764 130.628C168.751 127.33 171.582 124.707 174.921 123.067ZM90.7356 194.712V200.677H96.3696V194.712H90.7356ZM90.22 207.677H87.4543C86.5842 207.677 85.7496 207.309 85.1343 206.651C84.5188 205.995 84.1731 205.106 84.1731 204.178V194.71C81.0919 194.675 78.1479 193.346 75.9792 191.011C73.8105 188.675 72.5917 185.523 72.5871 182.237V171.528H19.5934V219.418H90.2187L90.22 207.677ZM172.267 194.712H166.632V199.677C166.632 199.942 166.731 200.197 166.906 200.384C167.082 200.571 167.32 200.677 167.569 200.677H171.328C171.577 200.677 171.816 200.571 171.991 200.384C172.167 200.197 172.266 199.942 172.266 199.677L172.267 194.712ZM76.773 141.627C78.8824 141.54 81.3667 142.053 82.9525 143.606C83.4519 144.101 83.8518 144.699 84.1276 145.364C84.4036 146.03 84.5499 146.748 84.5575 147.475C84.6237 149.316 84.0987 151.753 82.7851 153.002C81.6451 154.086 79.6801 154.756 76.4145 154.58C73.8753 153.738 71.6463 152.071 70.0393 149.812C68.8351 148.108 68.0275 146.123 67.6836 144.021C67.3395 141.92 67.4688 139.76 68.0607 137.722C68.6527 135.684 69.6903 133.825 71.088 132.299C72.4857 130.772 74.2036 129.622 76.0999 128.943C77.9962 128.264 80.0167 128.075 81.9949 128.393C83.973 128.71 85.852 129.525 87.477 130.769C89.1021 132.013 90.4266 133.652 91.3414 135.549C92.2563 137.447 92.7351 139.549 92.7387 141.683V159.062C92.742 161.576 93.6798 163.986 95.3464 165.763C97.0131 167.541 99.2725 168.542 101.629 168.546H161.373C163.731 168.542 165.99 167.541 167.656 165.763C169.323 163.986 170.26 161.576 170.263 159.062V141.683C170.26 139.543 170.736 137.434 171.649 135.529C172.563 133.624 173.887 131.979 175.515 130.729C177.142 129.479 179.026 128.66 181.009 128.34C182.992 128.02 185.019 128.208 186.919 128.889C188.821 129.57 190.543 130.724 191.943 132.256C193.344 133.788 194.382 135.653 194.973 137.697C195.564 139.742 195.69 141.907 195.34 144.014C194.991 146.12 194.176 148.108 192.963 149.812C191.356 152.071 189.127 153.738 186.588 154.58C183.322 154.756 181.357 154.086 180.219 153.002C178.906 151.752 178.38 149.317 178.446 147.476C178.453 146.748 178.6 146.03 178.876 145.365C179.151 144.7 179.551 144.101 180.051 143.606C181.638 142.053 184.122 141.54 186.231 141.627C186.661 141.646 187.092 141.574 187.497 141.415C187.902 141.257 188.272 141.014 188.589 140.701C188.905 140.389 189.162 140.013 189.34 139.594C189.52 139.176 189.621 138.724 189.636 138.264C189.651 137.804 189.582 137.346 189.429 136.915C189.277 136.484 189.048 136.09 188.752 135.754C188.458 135.419 188.103 135.149 187.71 134.96C187.317 134.771 186.892 134.667 186.46 134.654C182.554 134.494 178.552 135.592 175.615 138.465C174.472 139.582 173.556 140.934 172.918 142.441C172.281 143.948 171.937 145.577 171.909 147.23C171.763 151.25 172.989 155.495 175.86 158.225C177.703 159.975 180.27 161.218 183.853 161.522V182.237C183.849 183.686 183.307 185.077 182.344 186.104C181.383 187.13 180.079 187.707 178.719 187.712H84.2824C82.9222 187.707 81.6189 187.13 80.6571 186.102C79.6954 185.077 79.1533 183.686 79.1496 182.237V161.522C82.7317 161.218 85.2996 159.976 87.1413 158.225C90.0129 155.495 91.2387 151.249 91.0933 147.229C91.0647 145.576 90.7212 143.947 90.0838 142.441C89.4465 140.934 88.5286 139.582 87.3859 138.465C84.4512 135.594 80.4484 134.493 76.5409 134.654C76.1098 134.667 75.6853 134.771 75.2919 134.96C74.8986 135.149 74.5441 135.419 74.2489 135.754C73.9539 136.09 73.7238 136.484 73.5723 136.915C73.4206 137.346 73.3504 137.804 73.3656 138.264C73.3807 138.724 73.4811 139.176 73.6608 139.594C73.8405 140.013 74.0961 140.389 74.4126 140.701C74.7292 141.014 75.1006 141.257 75.5055 141.415C75.9103 141.574 76.342 141.646 76.773 141.627Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    title: "Donation",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            Win a home and donate to one of our charity partners at checkout.
            It’s time to dream big and do good.
          </li>
        </ul>
      </React.Fragment>
    ),
    icon: (
      <svg
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        tabIndex="-1"
        title="Donation"
      >
        <path d="m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"></path>
      </svg>
    ),
  },
  {
    title: "Bonus Draw",
    answer: (
      <React.Fragment>
        <ul className="faq-list dark">
          <li>
            Buy Dream Home tickets before midnight on September 30 to also win a
            Porsche 718 Cayman worth £65,000 – or take the cash, tax-free.
          </li>
        </ul>
      </React.Fragment>
    ),
    icon: (
      <svg
        width="150"
        height="110"
        viewBox="0 0 150 110"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M147.669 50.0016H93.5359C92.2429 53.8376 89.6946 57.1257 86.3026 59.335C82.9626 61.575 77.7759 62.7483 72.6693 63.1416L82.6559 73.135C83.1199 73.5994 83.4879 74.1507 83.7389 74.7573C83.9898 75.364 84.1188 76.0141 84.1185 76.6707C84.1182 77.3272 83.9886 77.9772 83.7371 78.5836C83.4855 79.19 83.117 79.741 82.6526 80.205C82.1882 80.669 81.6369 81.037 81.0302 81.2879C80.4236 81.5388 79.7734 81.6678 79.1169 81.6675C78.4604 81.6672 77.8104 81.5376 77.204 81.2861C76.5975 81.0346 76.0466 80.6661 75.5826 80.2016L64.5493 69.1683V106.668H129.336C134.196 106.668 138.863 104.735 142.303 101.302C145.737 97.8601 147.667 93.1972 147.669 88.335V50.0016ZM25.1359 50.0016H4.33594V88.335C4.33594 93.195 6.26927 97.8616 9.7026 101.302C13.1441 104.736 17.8071 106.666 22.6693 106.668H54.5493V68.7416L43.0893 80.2016C42.1467 81.1129 40.8839 81.6175 39.5729 81.6067C38.2619 81.5959 37.0076 81.0707 36.0801 80.1441C35.1526 79.2174 34.6262 77.9636 34.6142 76.6526C34.6022 75.3417 35.1056 74.0784 36.0159 73.135L46.0026 63.1416C40.8959 62.7483 35.7093 61.575 32.3693 59.335C28.9773 57.1257 26.429 53.8376 25.1359 50.0016ZM34.3226 44.6816C34.394 43.8084 34.708 42.9725 35.2293 42.2683C37.3693 39.3416 41.9493 39.275 45.3893 41.5816C47.5359 43.015 49.1559 45.9483 50.5093 48.8083C51.2426 50.355 51.8759 51.9083 52.3959 53.3283C50.5792 53.3586 48.762 53.3119 46.9493 53.1883C43.6093 52.9416 40.1159 52.4883 37.9226 51.0216C35.8093 49.6083 34.4493 47.475 34.3226 45.4016L34.3359 45.0016L34.3226 44.6816ZM84.3493 45.4016C84.2226 47.475 82.8626 49.6083 80.7493 51.0216C78.5559 52.4883 75.0626 52.9416 71.7226 53.1883C69.8159 53.3216 67.9426 53.355 66.2759 53.3283C66.7959 51.9083 67.4293 50.355 68.1626 48.8083C69.5159 45.9483 71.1359 43.015 73.2826 41.5816C76.7226 39.275 81.3026 39.3416 83.4426 42.2683C83.9639 42.9725 84.2779 43.8084 84.3493 44.6816C84.3324 44.9213 84.3324 45.1619 84.3493 45.4016ZM64.5493 3.33496V36.075C65.5559 34.9683 66.6159 34.0083 67.7226 33.2683C75.8293 27.8483 86.4626 29.4683 91.5093 36.3483C92.3426 37.495 92.9893 38.7216 93.4559 40.0016H147.669V21.6683C147.669 16.8083 145.736 12.1416 142.303 8.70163C138.861 5.26693 134.198 3.337 129.336 3.33496H64.5493ZM54.5493 3.33496H22.6693C17.8093 3.33496 13.1426 5.26829 9.7026 8.70163C6.26791 12.1431 4.33798 16.8061 4.33594 21.6683V40.0016H25.2159C25.6826 38.7216 26.3293 37.495 27.1626 36.3483C32.2093 29.4683 42.8426 27.8483 50.9493 33.2683C52.2159 34.115 53.4226 35.2483 54.5493 36.5683V3.33496Z"
          fill="white"
        />
      </svg>
    ),
  },
];

const dreamDrawFeatures = [
  {
    title: "5 bedrooms",
    icon: (
      <svg
        width="39"
        height="28"
        viewBox="0 0 39 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.7382 17.5156V5.79691C33.1494 5.79691 31.0507 3.69825 31.0507 1.10943H7.61327C7.61327 3.69825 5.5146 5.79691 2.92578 5.79691V17.5156V16.3438C2.92578 14.4021 4.49976 12.8281 6.4414 12.8281H32.2226C34.1642 12.8281 35.7382 14.4021 35.7382 16.3438V17.5156Z"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M7.61328 12.8281V10.4844C7.61328 9.18993 8.66265 8.14064 9.95702 8.14064H14.6445C15.9389 8.14064 16.9883 9.18993 16.9883 10.4844V12.8281"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M21.6758 12.8281V10.4844C21.6758 9.18993 22.7252 8.14064 24.0195 8.14064H28.707C30.0014 8.14064 31.0508 9.18993 31.0508 10.4844V12.8281"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M0.503906 26.8906V17.5157H38.16V26.8906H33.3944V24.5469H5.26952V26.8906H0.503906Z"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
      </svg>
    ),
  },
  {
    title: "4 bathrooms",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.7187 27.3438H22.3438V20.3125C22.3438 19.0181 23.3931 17.9688 24.6875 17.9688H29.375C30.6694 17.9688 31.7187 19.0181 31.7187 20.3125V27.3438Z"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M20 10.5469C20 7.95805 17.9014 5.85939 15.3125 5.85939C12.7236 5.85939 10.625 7.95805 10.625 10.5469H20Z"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M15.3125 5.85942C15.3125 3.2706 13.2138 1.17193 10.625 1.17193H8.28124C5.69242 1.17193 3.59375 3.2706 3.59375 5.85942V20.3125"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M3.59375 25V29.6875C3.59375 33.5708 6.74171 36.7188 10.625 36.7188H29.3749C33.2582 36.7188 36.4061 33.5708 36.4061 29.6875V25"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M31.418 36.5264L34.063 39.1714"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M8.58249 36.5264L5.9375 39.1714"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M31.7188 20.3125H36.4844C37.7787 20.3125 38.8281 21.3618 38.8281 22.6563C38.8281 23.9507 37.7787 25 36.4844 25H31.7188"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M22.3437 25H3.51562C2.22125 25 1.17188 23.9507 1.17188 22.6563C1.17188 21.3618 2.22125 20.3125 3.51562 20.3125H22.3438"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
      </svg>
    ),
  },
  {
    title: "4 living rooms",
    icon: (
      <svg
        width="39"
        height="40"
        viewBox="0 0 39 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.94529 34.1406H3.25781V27.1094H0.835938V24.7657C0.835938 23.4712 1.88531 22.4219 3.17968 22.4219H5.60155C6.89592 22.4219 7.94529 23.4712 7.94529 24.7657V30.625"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M31.3827 34.1406H36.0702V27.1094H38.4921V24.7657C38.4921 23.4712 37.4427 22.4219 36.1484 22.4219H33.7265C32.4321 22.4219 31.3827 23.4712 31.3827 24.7657V30.625M31.3827 34.1406H7.94531V30.625C7.94531 28.6834 9.51929 27.1094 11.4609 27.1094H27.8671C29.8088 27.1094 31.3827 28.6834 31.3827 30.625M31.3827 34.1406V30.625"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M36.0685 22.4219L36.4008 21.7573C38.2056 18.1476 36.0143 13.8196 32.0366 13.1378L31.9542 13.1236C29.9234 12.7852 27.8379 13.1508 26.0433 14.1599C24.6547 12.0295 22.2668 10.7032 19.6623 10.7032C17.0693 10.7032 14.6908 12.0179 13.2996 14.1321C11.4807 13.075 9.34651 12.6957 7.27479 13.0611C3.26027 13.7691 1.22519 18.36 3.04831 22.0062L3.25613 22.4219"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M14.9766 17.7344L17.3203 22.4219"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M24.3516 17.7344L22.0078 22.4219"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M3.2539 1.1719L1.22266 8.20312H14.6681L12.6368 1.1719H3.2539Z"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M7.94531 8.20331V12.9692"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M5.60156 34.1406V38.8281H10.289V34.1406"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
        <path
          d="M29.0391 34.1406V38.8281H33.7265V34.1406"
          stroke="#2E2E2E"
          strokeMiterlimit="10"
        />
      </svg>
    ),
  },
  {
    title: "Wine cellar",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8365_1903)">
          <path
            d="M20 0C14.6975 0.00595527 9.61388 2.115 5.86444 5.86444C2.115 9.61388 0.00595527 14.6975 0 20L0 39.4531C0 39.5982 0.057617 39.7373 0.160176 39.8398C0.262735 39.9424 0.401835 40 0.546875 40H39.4531C39.5982 40 39.7373 39.9424 39.8398 39.8398C39.9424 39.7373 40 39.5982 40 39.4531V20C39.994 14.6975 37.885 9.61388 34.1356 5.86444C30.3861 2.115 25.3025 0.00595527 20 0ZM38.9062 38.9062H1.09375V20C1.09375 14.9858 3.08565 10.1769 6.63126 6.63126C10.1769 3.08565 14.9858 1.09375 20 1.09375C25.0142 1.09375 29.8231 3.08565 33.3687 6.63126C36.9143 10.1769 38.9062 14.9858 38.9062 20V38.9062Z"
            fill="black"
          />
          <path
            d="M28.09 12.9037L21.3809 19.6124C21.2785 19.715 21.2209 19.854 21.2209 19.999C21.2209 20.144 21.2785 20.283 21.3809 20.3856L28.09 27.0937C28.1407 27.1445 28.201 27.1848 28.2673 27.2123C28.3337 27.2398 28.4048 27.254 28.4766 27.254C28.5484 27.254 28.6195 27.2398 28.6858 27.2123C28.7521 27.1848 28.8124 27.1445 28.8631 27.0937L35.5722 20.3849C35.6747 20.2824 35.7322 20.1433 35.7322 19.9984C35.7322 19.8534 35.6747 19.7144 35.5722 19.6118L28.8631 12.9037C28.8124 12.8529 28.7521 12.8126 28.6858 12.785C28.6195 12.7575 28.5484 12.7434 28.4766 12.7434C28.4048 12.7434 28.3337 12.7575 28.2673 12.785C28.201 12.8126 28.1407 12.8529 28.09 12.9037ZM26.1562 22.6506C26.1563 22.2689 26.2504 21.8931 26.4302 21.5565C26.6101 21.2199 26.8701 20.9328 27.1874 20.7206C27.5046 20.5085 27.8693 20.3778 28.2491 20.3401C28.6289 20.3025 29.0121 20.359 29.3648 20.5048C29.7176 20.6506 30.0289 20.881 30.2714 21.1758C30.5138 21.4705 30.6799 21.8205 30.7548 22.1947C30.8297 22.569 30.8113 22.9559 30.701 23.3213C30.5908 23.6867 30.3922 24.0193 30.1228 24.2896L30.1169 24.2956C29.7918 24.6194 29.3781 24.8397 28.9279 24.9286C28.4777 25.0175 28.0113 24.971 27.5875 24.795C27.1638 24.619 26.8016 24.3213 26.5469 23.9397C26.2922 23.558 26.1562 23.1094 26.1562 22.6506ZM34.4119 19.9999L31.8863 22.5259C31.8557 21.642 31.4832 20.8045 30.8471 20.19C30.211 19.5755 29.3611 19.232 28.4767 19.232C27.5923 19.232 26.7424 19.5755 26.1064 20.19C25.4703 20.8045 25.0977 21.642 25.0672 22.5259L22.5413 19.9999L28.4766 14.0624L34.4119 19.9999ZM28.09 10.1412C28.1407 10.192 28.201 10.2323 28.2673 10.2598C28.3337 10.2873 28.4048 10.3015 28.4766 10.3015C28.5484 10.3015 28.6195 10.2873 28.6858 10.2598C28.7521 10.2323 28.8124 10.192 28.8631 10.1412L31.4491 7.55555C31.5023 7.50243 31.544 7.43889 31.5715 7.3689C31.5991 7.29891 31.6119 7.22399 31.6091 7.14883C31.6064 7.07367 31.5881 6.99989 31.5555 6.93211C31.5229 6.86433 31.4767 6.80401 31.4197 6.75493C28.7524 4.44132 25.4437 2.99496 21.9341 2.60837C21.8214 2.59577 21.7077 2.6185 21.6085 2.6734C21.5094 2.72831 21.4298 2.81267 21.3807 2.91482C21.3316 3.01697 21.3155 3.13186 21.3346 3.24357C21.3536 3.35528 21.407 3.4583 21.4872 3.53837L28.09 10.1412ZM30.2525 7.20555L28.4766 8.98118L23.4575 3.96212C25.9447 4.49788 28.2718 5.60869 30.2525 7.20555ZM32.8503 8.39024C32.7752 8.38704 32.7003 8.3996 32.6303 8.4271C32.5603 8.4546 32.4969 8.49644 32.4441 8.54993L29.8581 11.1359C29.7556 11.2384 29.6981 11.3775 29.6981 11.5224C29.6981 11.6674 29.7556 11.8064 29.8581 11.909L36.4613 18.5118C36.5413 18.592 36.6443 18.6453 36.756 18.6644C36.8676 18.6835 36.9825 18.6674 37.0846 18.6183C37.1867 18.5693 37.2711 18.4897 37.3261 18.3906C37.381 18.2916 37.4038 18.1778 37.3913 18.0652C37.0048 14.5555 35.5584 11.2466 33.2447 8.5793C33.1955 8.52232 33.1351 8.47612 33.0672 8.44358C32.9994 8.41105 32.9255 8.39289 32.8503 8.39024ZM31.0178 11.5224L32.7934 9.7468C34.3907 11.7272 35.5016 14.0545 36.0369 16.5418L31.0178 11.5224ZM12.7444 11.5224C12.7444 11.5942 12.7585 11.6653 12.7859 11.7316C12.8134 11.798 12.8536 11.8582 12.9044 11.909L19.6134 18.6177C19.6642 18.6686 19.7244 18.7089 19.7908 18.7364C19.8571 18.7639 19.9282 18.778 20 18.778C20.0718 18.778 20.1429 18.7639 20.2092 18.7364C20.2756 18.7089 20.3358 18.6686 20.3866 18.6177L27.0956 11.909C27.1981 11.8064 27.2557 11.6674 27.2557 11.5224C27.2557 11.3775 27.1981 11.2384 27.0956 11.1359L20.3866 4.42712C20.3358 4.3763 20.2756 4.33599 20.2092 4.30848C20.1429 4.28098 20.0718 4.26682 20 4.26682C19.9282 4.26682 19.8571 4.28098 19.7908 4.30848C19.7244 4.33599 19.6642 4.3763 19.6134 4.42712L12.9044 11.1359C12.8536 11.1866 12.8134 11.2469 12.7859 11.3132C12.7585 11.3796 12.7444 11.4506 12.7444 11.5224ZM17.6781 14.174C17.678 13.7923 17.7721 13.4165 17.9518 13.0798C18.1316 12.7431 18.3916 12.4559 18.7089 12.2437C19.0261 12.0315 19.3908 11.9007 19.7706 11.863C20.1504 11.8253 20.5337 11.8818 20.8864 12.0275C21.2392 12.1732 21.5506 12.4036 21.7931 12.6984C22.0356 12.9932 22.2017 13.3432 22.2766 13.7174C22.3516 14.0917 22.3332 14.4786 22.2229 14.844C22.1127 15.2095 21.9141 15.5421 21.6447 15.8124L21.6388 15.8184C21.2033 16.2514 20.6141 16.4945 20 16.4945C19.3859 16.4945 18.7967 16.2514 18.3613 15.8184L18.3553 15.8124C18.14 15.5975 17.9693 15.342 17.8531 15.0608C17.7369 14.7797 17.6774 14.4783 17.6781 14.174ZM20 5.58712L25.9353 11.5224L23.4097 14.0484C23.3792 13.1645 23.0066 12.327 22.3705 11.7125C21.7344 11.098 20.8846 10.7545 20.0002 10.7545C19.1157 10.7545 18.2659 11.098 17.6298 11.7125C16.9937 12.327 16.6211 13.1645 16.5906 14.0484L14.0647 11.5224L20 5.58712ZM11.1369 12.9037L4.42781 19.6124C4.32534 19.715 4.26777 19.854 4.26777 19.999C4.26777 20.144 4.32534 20.283 4.42781 20.3856L11.1369 27.0937C11.1876 27.1445 11.2479 27.1848 11.3142 27.2123C11.3805 27.2398 11.4516 27.254 11.5234 27.254C11.5952 27.254 11.6663 27.2398 11.7327 27.2123C11.799 27.1848 11.8593 27.1445 11.91 27.0937L18.6191 20.3856C18.7215 20.283 18.7791 20.144 18.7791 19.999C18.7791 19.854 18.7215 19.715 18.6191 19.6124L11.91 12.9037C11.8593 12.8529 11.799 12.8126 11.7327 12.785C11.6663 12.7575 11.5952 12.7434 11.5234 12.7434C11.4516 12.7434 11.3805 12.7575 11.3142 12.785C11.2479 12.8126 11.1876 12.8529 11.1369 12.9037ZM9.20156 22.6506C9.20158 22.2689 9.29569 21.8931 9.47554 21.5565C9.65539 21.2199 9.91546 20.9328 10.2327 20.7206C10.55 20.5085 10.9146 20.3778 11.2944 20.3401C11.6742 20.3025 12.0574 20.359 12.4102 20.5048C12.7629 20.6506 13.0742 20.881 13.3167 21.1758C13.5591 21.4705 13.7252 21.8205 13.8001 22.1947C13.8751 22.569 13.8566 22.9559 13.7464 23.3213C13.6361 23.6867 13.4375 24.0193 13.1681 24.2896L13.1622 24.2956C12.8371 24.6194 12.4234 24.8397 11.9732 24.9286C11.523 25.0175 11.0566 24.971 10.6328 24.795C10.2091 24.619 9.84695 24.3213 9.59221 23.9397C9.33748 23.558 9.20154 23.1094 9.20156 22.6506ZM14.9331 22.5256C14.9026 21.6417 14.53 20.8042 13.894 20.1897C13.2579 19.5752 12.408 19.2317 11.5236 19.2317C10.6392 19.2317 9.78931 19.5752 9.15324 20.1897C8.51716 20.8042 8.14458 21.6417 8.11406 22.5256L5.58813 19.9999L11.5234 14.0624L17.4588 19.9999L14.9331 22.5256ZM27.2556 28.4756C27.2556 28.4038 27.2415 28.3327 27.2141 28.2664C27.1866 28.2 27.1464 28.1398 27.0956 28.089L20.3866 21.3799C20.2821 21.2811 20.1438 21.2261 20 21.2261C19.8562 21.2261 19.7179 21.2811 19.6134 21.3799L12.9044 28.089C12.8019 28.1915 12.7443 28.3306 12.7443 28.4756C12.7443 28.6205 12.8019 28.7596 12.9044 28.8621L19.6134 35.5709C19.6642 35.6217 19.7244 35.662 19.7908 35.6895C19.8571 35.717 19.9282 35.7312 20 35.7312C20.0718 35.7312 20.1429 35.717 20.2092 35.6895C20.2756 35.662 20.3358 35.6217 20.3866 35.5709L27.0956 28.8621C27.1464 28.8113 27.1866 28.7511 27.2141 28.6847C27.2415 28.6184 27.2556 28.5473 27.2556 28.4756ZM17.6781 31.1271C17.6782 30.5899 17.8644 30.0694 18.2052 29.6542C18.546 29.2389 19.0203 28.9547 19.5471 28.85C20.074 28.7452 20.6209 28.8263 21.0946 29.0796C21.5684 29.3328 21.9396 29.7425 22.1452 30.2388C22.3507 30.7351 22.3778 31.2873 22.2219 31.8013C22.0659 32.3154 21.7365 32.7594 21.2899 33.0579C20.8432 33.3563 20.3069 33.4906 19.7723 33.4379C19.2377 33.3853 18.738 33.1488 18.3581 32.769C18.1418 32.5539 17.9704 32.298 17.8537 32.0162C17.7369 31.7343 17.6773 31.4322 17.6781 31.1271ZM23.4097 31.0021C23.378 30.1189 23.005 29.2825 22.369 28.6689C21.733 28.0553 20.8837 27.7124 20 27.7124C19.1163 27.7124 18.267 28.0553 17.631 28.6689C16.995 29.2825 16.622 30.1189 16.5903 31.0021L14.0647 28.4762L20 22.5399L25.9353 28.4756L23.4097 31.0021ZM11.91 29.8565C11.8055 29.7576 11.6671 29.7025 11.5233 29.7025C11.3794 29.7025 11.241 29.7576 11.1366 29.8565L4.42781 36.5656C4.35106 36.642 4.29874 36.7395 4.27748 36.8457C4.25621 36.9519 4.26697 37.062 4.30837 37.1621C4.34978 37.2622 4.41998 37.3477 4.51006 37.4079C4.60015 37.468 4.70606 37.5001 4.81438 37.4999H18.2322C18.3403 37.4999 18.446 37.4678 18.5359 37.4077C18.6258 37.3476 18.6958 37.2622 18.7372 37.1623C18.7785 37.0624 18.7894 36.9525 18.7683 36.8464C18.7472 36.7404 18.6952 36.643 18.6188 36.5665L11.91 29.8565ZM6.13469 36.4062L11.5231 31.0165L16.9119 36.4062H6.13469ZM11.1369 10.1412C11.1876 10.192 11.2479 10.2323 11.3142 10.2598C11.3805 10.2873 11.4516 10.3015 11.5234 10.3015C11.5952 10.3015 11.6663 10.2873 11.7327 10.2598C11.799 10.2323 11.8593 10.192 11.91 10.1412L18.5128 3.53837C18.593 3.4583 18.6464 3.35528 18.6654 3.24357C18.6845 3.13186 18.6684 3.01697 18.6193 2.91482C18.5702 2.81267 18.4906 2.72831 18.3915 2.6734C18.2923 2.6185 18.1786 2.59577 18.0659 2.60837C14.5563 2.99496 11.2476 4.44132 8.58031 6.75493C8.52332 6.80401 8.47708 6.86433 8.44448 6.93211C8.41188 6.99989 8.39363 7.07367 8.39087 7.14883C8.38811 7.22399 8.40091 7.29891 8.42845 7.3689C8.456 7.43889 8.49769 7.50243 8.55094 7.55555L11.1369 10.1412ZM16.5431 3.96212L11.5234 8.98118L9.7475 7.20555C11.7282 5.60869 14.0553 4.49788 16.5425 3.96212H16.5431ZM37.1625 21.2615C37.0625 21.2204 36.9526 21.2098 36.8466 21.2309C36.7406 21.252 36.6432 21.304 36.5666 21.3802L29.8578 28.089C29.807 28.1397 29.7667 28.2 29.7392 28.2663C29.7117 28.3326 29.6975 28.4037 29.6975 28.4756C29.6975 28.5474 29.7117 28.6185 29.7392 28.6848C29.7667 28.7511 29.807 28.8114 29.8578 28.8621L36.5666 35.5709C36.643 35.6474 36.7404 35.6996 36.8465 35.7208C36.9526 35.742 37.0626 35.7312 37.1626 35.6898C37.2625 35.6484 37.3479 35.5782 37.408 35.4883C37.4681 35.3983 37.5001 35.2925 37.5 35.1843V21.7668C37.5 21.6587 37.4679 21.5529 37.4078 21.463C37.3478 21.3731 37.2624 21.3029 37.1625 21.2615ZM36.4062 33.864L31.0178 28.4756L36.4062 23.0871V33.864ZM28.8634 29.8565C28.759 29.7576 28.6206 29.7025 28.4767 29.7025C28.3329 29.7025 28.1945 29.7576 28.09 29.8565L21.3812 36.5656C21.3045 36.642 21.2522 36.7395 21.2309 36.8457C21.2096 36.9519 21.2204 37.062 21.2618 37.1621C21.3032 37.2622 21.3734 37.3477 21.4635 37.4079C21.5536 37.468 21.6595 37.5001 21.7678 37.4999H35.1856C35.2937 37.4999 35.3994 37.4678 35.4893 37.4077C35.5792 37.3476 35.6492 37.2622 35.6906 37.1623C35.732 37.0624 35.7428 36.9525 35.7217 36.8464C35.7007 36.7404 35.6486 36.643 35.5722 36.5665L28.8634 29.8565ZM23.0881 36.4062L28.4769 31.0165L33.8653 36.4062H23.0881ZM2.91594 18.6181C3.01822 18.6676 3.1334 18.6839 3.24543 18.6649C3.35745 18.6458 3.46075 18.5923 3.54094 18.5118L10.1441 11.909C10.2465 11.8064 10.3041 11.6674 10.3041 11.5224C10.3041 11.3775 10.2465 11.2384 10.1441 11.1359L7.55656 8.54993C7.50412 8.49593 7.44075 8.45375 7.37069 8.42621C7.30063 8.39867 7.22549 8.38641 7.15031 8.39024C7.0752 8.39294 7.00145 8.41112 6.93369 8.44365C6.86594 8.47619 6.80563 8.52237 6.75656 8.5793C4.44262 11.2466 2.99603 14.5554 2.60938 18.0652C2.59691 18.1778 2.61972 18.2914 2.67463 18.3905C2.72955 18.4895 2.81387 18.569 2.91594 18.6181ZM7.20656 9.7468L8.98219 11.5224L3.96313 16.5418C4.49842 14.0545 5.60928 11.7272 7.20656 9.7468ZM10.1422 28.089L3.43344 21.3802C3.35702 21.3037 3.25959 21.2515 3.15349 21.2303C3.04739 21.2092 2.9374 21.22 2.83744 21.2613C2.73748 21.3027 2.65206 21.3729 2.59199 21.4629C2.53192 21.5528 2.4999 21.6586 2.5 21.7668V35.1843C2.4999 35.2925 2.53192 35.3983 2.59199 35.4883C2.65206 35.5782 2.73748 35.6484 2.83744 35.6898C2.9374 35.7312 3.04739 35.742 3.15349 35.7208C3.25959 35.6996 3.35702 35.6474 3.43344 35.5709L10.1422 28.8621C10.193 28.8114 10.2333 28.7511 10.2608 28.6848C10.2883 28.6185 10.3025 28.5474 10.3025 28.4756C10.3025 28.4037 10.2883 28.3326 10.2608 28.2663C10.2333 28.2 10.193 28.1397 10.1422 28.089ZM3.59375 33.864V23.0871L8.98219 28.4756L3.59375 33.864Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_8365_1903">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    title: "2 garages",
    icon: (
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M38.4279 11.8439L20.9792 1.2773C20.8824 1.21825 20.7711 1.18701 20.6578 1.18701C20.5444 1.18701 20.4332 1.21825 20.3363 1.2773L2.89884 11.8439C2.80937 11.9007 2.73632 11.98 2.68698 12.0738C2.63763 12.1676 2.61371 12.2726 2.61759 12.3786V38.1885C2.61759 38.5336 2.86158 38.8283 3.20674 38.8283H6.92759C7.09351 38.8244 7.25111 38.7548 7.36581 38.6349C7.48052 38.5149 7.54297 38.3544 7.53947 38.1885V20.4689H33.7895V38.1885C33.786 38.3544 33.8484 38.5149 33.9631 38.6349C34.0778 38.7548 34.2354 38.8244 34.4013 38.8283H38.1222C38.4674 38.8283 38.7113 38.5336 38.7113 38.1885V12.3787C38.7148 12.2726 38.6905 12.1674 38.6408 12.0736C38.5911 11.9798 38.5177 11.9006 38.4279 11.8439ZM7.53947 19.2189V16.7189H33.7895V19.2189H7.53947ZM37.4613 37.5783H35.0395V16.0996C35.0367 15.9319 34.9684 15.772 34.8491 15.6541C34.7298 15.5362 34.5691 15.4697 34.4013 15.4689H6.92759C6.75987 15.4697 6.59913 15.5362 6.47984 15.6541C6.36055 15.772 6.29221 15.9319 6.28947 16.0996V37.5783H3.86759V12.7311L20.6645 2.54254L37.4613 12.7311V37.5783Z"
          fill="#2E2E2E"
        />
        <path
          d="M30.3727 27.4915L28.7209 23.0214C28.5717 22.6191 28.3038 22.2716 27.9526 22.025C27.6015 21.7784 27.1836 21.6443 26.7546 21.6406H14.8682C14.4392 21.6444 14.0214 21.7785 13.6702 22.025C13.319 22.2716 13.0511 22.6191 12.9018 23.0214L11.2731 27.4233L10.6314 28.0286C10.3217 28.2953 10.0735 28.6259 9.90388 28.9976C9.73422 29.3694 9.64711 29.7735 9.64855 30.1821V38.1883C9.64539 38.3544 9.70815 38.5149 9.8231 38.6349C9.93806 38.7548 10.0958 38.8243 10.2619 38.8281H14.4326C14.5145 38.8261 14.5952 38.8079 14.67 38.7746C14.7448 38.7413 14.8124 38.6936 14.8687 38.6341C14.9251 38.5747 14.9691 38.5047 14.9984 38.4282C15.0276 38.3517 15.0415 38.2702 15.0392 38.1883V35.9375H26.2892V38.1883C26.2869 38.2702 26.3007 38.3517 26.33 38.4282C26.3592 38.5047 26.4033 38.5747 26.4596 38.6341C26.516 38.6936 26.5835 38.7413 26.6584 38.7746C26.7332 38.8079 26.8139 38.8261 26.8957 38.8281H31.0664C31.2325 38.8243 31.3903 38.7548 31.5052 38.6349C31.6202 38.5149 31.683 38.3544 31.6798 38.1883V30.0135C31.6802 29.6318 31.6036 29.2539 31.4546 28.9024C31.3056 28.5509 31.0873 28.2331 30.8126 27.968L30.3727 27.4915ZM14.0739 23.4687C14.1333 23.304 14.2407 23.1608 14.3823 23.0577C14.5239 22.9546 14.6932 22.8964 14.8682 22.8906H26.7546C26.9296 22.8964 27.0989 22.9546 27.2405 23.0577C27.3821 23.1608 27.4895 23.304 27.5489 23.4687L28.9171 27.1875H12.7056L14.0739 23.4687ZM13.7892 37.5781H10.8986V35.9375H13.7892V37.5781ZM27.5392 37.5781V35.9375H30.4298V37.5781H27.5392ZM30.4298 34.6875H10.8986V30.1821C10.8973 29.9528 10.9461 29.7259 11.0417 29.5174C11.1372 29.3089 11.2771 29.1238 11.4516 28.975C11.4588 28.9689 11.4629 28.9759 11.4699 28.9694L12.0532 28.4375H29.5212L29.9182 28.8484C29.9269 28.8579 29.9302 28.8604 29.9396 28.8692C30.095 29.0164 30.2187 29.1939 30.303 29.3907C30.3873 29.5875 30.4305 29.7994 30.4298 30.0135V34.6875Z"
          fill="#2E2E2E"
        />
        <path
          d="M13.9855 29.9219H13.625C13.1381 29.9219 12.6711 30.1153 12.3268 30.4596C11.9825 30.8039 11.7891 31.2709 11.7891 31.7578C11.7891 32.2447 11.9825 32.7117 12.3268 33.056C12.6711 33.4003 13.1381 33.5938 13.625 33.5938H13.9855C14.4724 33.5938 14.9394 33.4003 15.2837 33.056C15.628 32.7117 15.8214 32.2447 15.8214 31.7578C15.8214 31.2709 15.628 30.8039 15.2837 30.4596C14.9394 30.1153 14.4724 29.9219 13.9855 29.9219ZM13.9855 32.3438H13.625C13.4696 32.3438 13.3206 32.282 13.2107 32.1721C13.1008 32.0622 13.0391 31.9132 13.0391 31.7578C13.0391 31.6024 13.1008 31.4534 13.2107 31.3435C13.3206 31.2336 13.4696 31.1719 13.625 31.1719H13.9855C14.1409 31.1719 14.2899 31.2336 14.3998 31.3435C14.5097 31.4534 14.5714 31.6024 14.5714 31.7578C14.5714 31.9132 14.5097 32.0622 14.3998 32.1721C14.2899 32.282 14.1409 32.3438 13.9855 32.3438ZM27.7073 29.9219H27.3469C26.86 29.9219 26.393 30.1153 26.0487 30.4596C25.7044 30.8039 25.5109 31.2709 25.5109 31.7578C25.5109 32.2447 25.7044 32.7117 26.0487 33.056C26.393 33.4003 26.86 33.5938 27.3469 33.5938H27.7073C28.1943 33.5938 28.6612 33.4003 29.0055 33.056C29.3499 32.7117 29.5433 32.2447 29.5433 31.7578C29.5433 31.2709 29.3499 30.8039 29.0055 30.4596C28.6612 30.1153 28.1943 29.9219 27.7073 29.9219ZM27.7073 32.3438H27.3469C27.1915 32.3438 27.0424 32.282 26.9326 32.1721C26.8227 32.0622 26.7609 31.9132 26.7609 31.7578C26.7609 31.6024 26.8227 31.4534 26.9326 31.3435C27.0424 31.2336 27.1915 31.1719 27.3469 31.1719H27.7073C27.8627 31.1719 28.0118 31.2336 28.1217 31.3435C28.2315 31.4534 28.2933 31.6024 28.2933 31.7578C28.2933 31.9132 28.2315 32.0622 28.1217 32.1721C28.0118 32.282 27.8627 32.3438 27.7073 32.3438ZM24.4162 30.625C24.4162 30.4592 24.3503 30.3003 24.2331 30.1831C24.1159 30.0658 23.9569 30 23.7912 30H17.463C17.2973 30 17.1383 30.0658 17.0211 30.1831C16.9039 30.3003 16.838 30.4592 16.838 30.625V32.9688C16.838 33.1345 16.9039 33.2935 17.0211 33.4107C17.1383 33.5279 17.2973 33.5938 17.463 33.5938H23.7912C23.9569 33.5938 24.1159 33.5279 24.2331 33.4107C24.3503 33.2935 24.4162 33.1345 24.4162 32.9688V30.625ZM23.2443 32.3438H18.088V31.25H23.2443V32.3438Z"
          fill="#2E2E2E"
        />
      </svg>
    ),
  },
  {
    title: "Gym",
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8365_1885)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0674 39.4844C6.74868 39.4844 0 32.7357 0 24.417C0 16.1217 6.74868 9.37305 15.0674 9.37305C23.3626 9.37305 30.1113 16.1217 30.1113 24.417C30.1113 26.7837 29.6192 29.0098 28.5647 31.1188C28.4007 31.3766 28.0961 31.5172 27.7914 31.3766C27.5571 31.2125 27.3931 30.9313 27.5571 30.6267C28.4944 28.7052 29.01 26.5962 29.01 24.417C29.01 16.731 22.7065 10.4275 15.0205 10.4275C7.31107 10.4275 1.00762 16.731 1.00762 24.417C1.00762 32.1264 7.31107 38.4299 15.0205 38.4299C15.5126 38.4299 16.075 38.3596 16.5671 38.3127C16.8717 38.2658 17.1295 38.5236 17.1763 38.8282C17.2232 39.1329 16.9654 39.3672 16.6842 39.4375C16.1687 39.4844 15.6063 39.4844 15.0674 39.4844ZM18.4417 39.1329C18.1839 39.1329 17.9731 38.9688 17.8793 38.7345C17.8325 38.4299 17.9731 38.1252 18.2777 38.0784C21.2537 37.3754 23.9719 35.6414 25.8934 33.2981C26.0808 33.0403 26.4323 33.0403 26.6432 33.1809C26.901 33.3918 26.901 33.7433 26.737 33.9307C24.6749 36.5084 21.7692 38.3596 18.5354 39.1329C18.5354 39.086 18.4886 39.1329 18.4417 39.1329Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.45236 12.607H7.35863C7.054 12.5367 6.86654 12.3024 6.9134 11.9978L8.27251 2.22623C8.41311 1.21861 9.1161 0.515625 10.03 0.515625H20.0358C20.9497 0.515625 21.6527 1.21861 21.8167 2.22623L23.1758 11.9978C23.2227 12.3024 23.0118 12.5367 22.7072 12.607C22.4026 12.6539 22.1682 12.443 22.1214 12.1384L20.7623 2.36683C20.692 2.01533 20.4576 1.61697 20.1061 1.61697H10.0768C9.67849 1.61697 9.46759 1.96847 9.42072 2.36683L8.06161 12.1384C7.96788 12.3961 7.75699 12.607 7.45236 12.607Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.201 9.32629C20.1541 9.32629 20.1073 9.32629 20.037 9.27943C16.8267 8.22494 13.3117 8.22494 10.078 9.27943C9.89052 9.32629 9.72649 9.27943 9.5859 9.16226C9.42187 9.06853 9.375 8.88107 9.375 8.67017L10.1717 2.88224C10.242 2.62448 10.4295 2.43701 10.7341 2.43701H19.4512C19.6855 2.43701 19.9432 2.62448 19.9901 2.88224L20.8103 8.67017C20.8571 8.88107 20.7634 9.02166 20.5994 9.16226C20.4588 9.27943 20.3416 9.32629 20.201 9.32629ZM11.1793 3.53836L10.5935 8.01405C13.4992 7.21733 16.6861 7.21733 19.5918 8.01405L18.9825 3.53836H11.1793ZM31.1208 34.1418H19.2403C18.9356 34.1418 18.6779 33.884 18.6779 33.5794V30.8611C18.6779 30.5565 18.9356 30.3222 19.2403 30.3222H31.1208C31.4254 30.3222 31.6831 30.5565 31.6831 30.8611V33.5794C31.6831 33.884 31.4254 34.1418 31.1208 34.1418ZM19.8027 33.0404H30.5584V31.4235H19.8027V33.0404Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.1323 39.4845C31.7263 39.4845 30.625 38.3128 30.625 36.9537V27.4868C30.625 26.0808 31.7732 24.9795 33.1323 24.9795C34.5383 24.9795 35.6396 26.1277 35.6396 27.4868V36.9537C35.6396 38.3597 34.4914 39.4845 33.1323 39.4845ZM33.1323 26.034C32.3356 26.034 31.6795 26.6901 31.6795 27.4868V36.9537C31.6795 37.7739 32.3356 38.43 33.1323 38.43C33.929 38.43 34.5852 37.7739 34.5852 36.9537V27.4868C34.5383 26.6901 33.8822 26.034 33.1323 26.034Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.1015 37.2114C34.7968 37.2114 34.5391 36.9536 34.5391 36.649C34.5391 36.3678 34.7968 36.11 35.1015 36.11C36.1091 36.11 36.9058 35.1962 36.9058 34.0948V30.1112C36.9058 29.0099 36.1091 28.096 35.1015 28.096C34.7968 28.096 34.5391 27.8382 34.5391 27.557C34.5391 27.2524 34.7968 26.9946 35.1015 26.9946C36.7183 26.9946 38.0071 28.4006 38.0071 30.0643V34.0479C38.0071 35.8523 36.7183 37.2114 35.1015 37.2114Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.9134 34.4933H37.4682C37.1636 34.4933 36.9058 34.2355 36.9058 33.9309C36.9058 33.6497 37.1636 33.3919 37.4682 33.3919H37.9134C38.4758 33.3919 38.8742 32.8764 38.8742 32.2906V31.9859C38.8742 31.3767 38.429 30.8612 37.9134 30.8612H37.4682C37.1636 30.8612 36.9058 30.6268 36.9058 30.3222C36.9058 30.0176 37.1636 29.7598 37.4682 29.7598H37.9134C39.0851 29.7598 39.9755 30.7674 39.9755 31.9156V32.2203C39.9755 33.4856 39.0851 34.4933 37.9134 34.4933ZM17.2222 39.4845C15.8162 39.4845 14.7148 38.3128 14.7148 36.9537V27.4868C14.7148 26.0808 15.8631 24.9795 17.2222 24.9795C18.5813 24.9795 19.7529 26.1277 19.7529 27.4868V36.9537C19.7998 38.3597 18.6281 39.4845 17.2222 39.4845ZM17.2222 26.034C16.4254 26.034 15.7693 26.6901 15.7693 27.4868V36.9537C15.7693 37.7739 16.4254 38.43 17.2222 38.43C18.0423 38.43 18.675 37.7739 18.675 36.9537V27.4868C18.675 26.6901 18.0423 26.034 17.2222 26.034Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.2533 37.2114C13.6599 37.2114 12.3477 35.8054 12.3477 34.1417V30.1581C12.3477 28.4475 13.6599 27.0884 15.2533 27.0884C15.558 27.0884 15.8157 27.3461 15.8157 27.6508C15.8157 27.9554 15.558 28.2132 15.2533 28.2132C14.2457 28.2132 13.449 29.1036 13.449 30.205V34.1886C13.449 35.2899 14.2457 36.2038 15.2533 36.2038C15.558 36.2038 15.8157 36.4615 15.8157 36.7662C15.8157 37.0708 15.558 37.2114 15.2533 37.2114Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8862 34.4932H12.441C11.2928 34.4932 10.3789 33.4856 10.3789 32.3374V32.0328C10.3789 30.8143 11.2928 29.8535 12.441 29.8535H12.8862C13.1909 29.8535 13.4486 30.1113 13.4486 30.4159C13.4486 30.7205 13.1909 30.9783 12.8862 30.9783H12.441C11.8786 30.9783 11.4803 31.4704 11.4803 32.0796V32.3843C11.4803 32.9935 11.9489 33.4856 12.441 33.4856H12.8862C13.1909 33.4856 13.4486 33.7434 13.4486 34.048C13.4486 34.3526 13.1909 34.4932 12.8862 34.4932Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_8365_1885">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
];

const heroGalleryImages = [
  "TheSurreyDreamHome",
  "Kitchen",
  "DiningRoom",
  "SittingRoom",
  "LivingRoom",
  "Gym",
  "Bedrooms",
  "Bathrooms",
  "Terrace&garden",
];

const heroInfoData = [
  {
    title: "Key info",
    content: [
      "No purchase, payment or other financial contribution is necessary to enter or win any of our competitions. A free postal entry is available for all competitions.",
      'Entrants must be 18 or older. Full T&Cs can be found <a href="/legal/0" target="_blank">here</a>',
    ],
  },
  {
    title: "Key dates",
    content: [
      {
        text: 'Midnight September 30: The £65k Porsche Bonus Draw closes.',
        icon: (
          <svg width="91" height="78" viewBox="0 0 91 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.34094 56.2904V54.345H87.8319C88.04 56.012 87.9318 57.71 87.5145 59.326C87.0972 60.942 86.3804 62.4389 85.4119 63.717C84.4433 64.9951 83.2451 66.0252 81.8972 66.7385C80.5493 67.4519 79.0825 67.8321 77.5945 67.8541H14.5624C11.8519 67.8526 9.25274 66.6339 7.33613 64.4656C5.41952 62.2973 4.34221 59.3569 4.34094 56.2904ZM77.5623 10.5086C77.5623 10.5086 79.7159 18.945 79.8766 19.345H12.2963C12.497 18.959 13.246 15.9316 13.8449 13.511C14.2051 12.055 14.511 10.8187 14.6106 10.5086C15.3776 7.50688 16.9841 4.86731 19.1891 2.98571C21.3942 1.1041 24.079 0.081861 26.8409 0.0722656H65.332C68.0933 0.0845067 70.777 1.10775 72.9816 2.98896C75.1862 4.87017 76.7932 7.50825 77.5623 10.5086ZM5.69966 15.4148C7.33397 15.068 9.58169 14.5911 10.1749 14.8177C9.93218 15.7432 5.14451 25.545 5.14451 25.545L3.8588 25.2359C2.89556 24.9827 2.0392 24.3608 1.43456 23.4755C0.82993 22.5902 0.514138 21.4958 0.5406 20.3775C0.567062 19.2591 0.934155 18.1854 1.57979 17.338C2.22542 16.4905 3.10996 15.9214 4.08379 15.7268C4.36898 15.6972 4.97382 15.5688 5.69966 15.4148ZM82.0945 14.6723L86.9159 15.5814C87.9196 15.7629 88.8327 16.3448 89.4901 17.2219C90.1475 18.099 90.5056 19.2133 90.4998 20.3632C90.493 21.5331 90.1168 22.6618 89.4389 23.5453C88.761 24.4289 87.8263 25.0092 86.8034 25.1814C86.4307 24.5065 85.9608 23.7291 85.4703 22.9178C84.5734 21.4341 83.6079 19.8368 83.0427 18.545C82.6156 17.2717 82.2507 15.9727 81.9498 14.6541C81.9739 14.6541 81.998 14.6586 82.0221 14.6632C82.0462 14.6677 82.0703 14.6723 82.0945 14.6723Z"
              fill="#043B3B"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M81.6444 22.9632C81.5757 22.9783 81.5055 22.9844 81.4355 22.9814H10.7374C10.6673 22.9844 10.5972 22.9783 10.5284 22.9632L6.96058 29.0359C5.24771 31.9364 4.33586 35.3476 4.34094 38.8359V50.7086H87.8319V38.8359C88.118 32.9214 84.3878 27.5995 81.6444 22.9632Z"
              fill="#043B3B"
            />
            <path
              d="M14.5574 71.491C12.6127 71.4933 10.6909 71.0163 8.9257 70.0932C7.1605 69.17 5.59426 67.8229 4.33594 66.1455V72.1637C4.34104 73.6968 4.88385 75.165 5.84512 76.2457C6.8064 77.3264 8.10753 77.9312 9.46272 77.9273H14.2199C15.575 77.9312 16.8762 77.3264 17.8375 76.2457C18.7987 75.165 19.3415 73.6968 19.3466 72.1637V71.491C18.2811 71.4946 15.5827 71.4891 14.5574 71.491ZM84.6127 69.2546C81.2055 71.8601 76.818 71.5237 72.8162 71.491V72.1637C72.8162 73.6923 73.353 75.1583 74.3084 76.2392C75.2639 77.3201 76.5597 77.9273 77.9109 77.9273H82.7002C84.0554 77.9312 85.3565 77.3264 86.3178 76.2457C87.279 75.165 87.8218 73.6968 87.827 72.1637V66.1455C86.9066 67.3665 85.8218 68.4158 84.6127 69.2546Z"
              fill="#043B3B"
            />
            <path
              d="M41.4777 46.3148C42.2782 46.3148 42.911 45.5588 42.911 44.6227L42.8985 44.6126L42.9068 43.4061C42.9236 40.4524 42.186 38.2096 40.7233 36.7328C39.2857 35.266 37.2363 34.52 34.6294 34.5H34.6043L34.5247 34.51H34.4953C31.6957 34.51 29.5666 35.276 28.1668 36.7829C26.7502 38.3098 26.0251 40.5876 26.0084 43.5613L26 44.4875C26 45.4337 26.6245 46.1996 27.4166 46.1996C28.2087 46.1996 28.8416 45.4437 28.8499 44.5075V43.7966C28.8583 42.4299 29.0008 41.3636 29.29 40.5426C29.5498 39.7416 29.9229 39.0857 30.4174 38.6001C30.8952 38.1446 31.4736 37.8141 32.1483 37.6389C32.8776 37.4737 33.6362 37.3786 34.4115 37.3786H34.5205C35.388 37.3786 36.1927 37.4887 36.922 37.704C37.58 37.9193 38.1416 38.2547 38.6361 38.7603C39.0971 39.2209 39.4366 39.8066 39.709 40.6126C39.9521 41.4086 40.0779 42.4049 40.0695 43.5663L40.0611 44.6026C40.0611 45.5488 40.6772 46.3148 41.4777 46.3148Z"
              fill="#F8F4F0"
            />
            <path
              d="M64.5622 46.5C65.3543 46.5 65.9955 45.7441 65.9955 44.8079L65.9913 44.7979L65.9997 43.5914C66.0165 40.6377 65.2789 38.3849 63.8162 36.918C62.3828 35.4512 60.3334 34.6952 57.7265 34.6752H57.6888L57.6343 34.6952H57.5463C54.776 34.6952 52.6553 35.4612 51.2555 36.9681C49.8473 38.485 49.1222 40.7628 49.1055 43.7466L49.0971 44.6727C49.0971 45.6089 49.7299 46.3748 50.5137 46.3849C51.2974 46.3849 51.9386 45.6289 51.947 44.6927V43.9819C51.9554 42.6151 52.0979 41.5488 52.3787 40.7178C52.6511 39.8967 53.0283 39.2509 53.5061 38.7854C53.9755 38.3298 54.5622 38.0094 55.2412 37.8242C55.9872 37.6489 56.7458 37.5538 57.496 37.5538H57.605C58.4809 37.5638 59.294 37.674 60.0065 37.8892C60.6645 38.0845 61.2261 38.4299 61.729 38.9355C62.19 39.4161 62.5421 40.0219 62.7935 40.7979C63.045 41.5989 63.1707 42.5901 63.1624 43.7416L63.154 44.7879C63.154 45.724 63.7868 46.49 64.5622 46.5Z"
              fill="#F8F4F0"
            />
          </svg>
        ),
      },
      {
        text: 'Midnight October 31: The £4m Surrey Dream Home Draw closes.',
        icon: (
          <svg width="91" height="80" viewBox="0 0 91 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7692_4118)">
              <path
                d="M45.9108 0L6.93374 18.2606L6.65625 60.6595C11.7551 64.2386 25.6889 73.0166 45.44 73.1606C51.5943 73.1966 67.8769 72.4716 84.3824 61.1995L84.65 18.8005L45.9108 0ZM42.1994 43.6382C42.1994 44.5999 41.4512 45.3764 40.5047 45.3764C39.5583 45.3764 38.8299 44.5896 38.8299 43.6177L38.8398 42.5532C38.8497 41.3602 38.7011 40.3368 38.4137 39.5192C38.0916 38.6913 37.6902 38.0896 37.1452 37.6165C36.5604 37.0971 35.8965 36.7526 35.1185 36.5315C34.2563 36.3103 33.3049 36.1972 32.2792 36.1972H32.1504C31.2337 36.1972 30.3368 36.2949 29.4746 36.4646C28.6768 36.6446 27.993 36.984 27.4281 37.452C26.8434 37.9508 26.4024 38.6244 26.0952 39.4472C25.7533 40.2905 25.5848 41.3859 25.5749 42.7897V43.52C25.565 44.4816 24.8168 45.2581 23.8803 45.2581C22.9438 45.2581 22.2054 44.4713 22.2054 43.4994L22.2154 42.548C22.2352 39.4935 23.0924 37.1537 24.7672 35.5853C26.4223 34.0374 28.9395 33.2506 32.2495 33.2506H32.2842L32.3783 33.2403H32.4081C35.4901 33.2609 37.9132 34.0271 39.6128 35.5338C41.3421 37.0508 42.2142 39.3546 42.1944 42.3886L42.1845 43.6279L42.1994 43.6382ZM69.4922 43.8285C69.4922 44.7901 68.7341 45.5666 67.7976 45.5666C66.8809 45.5563 66.1327 44.7696 66.1327 43.8079L66.1426 42.7332C66.1525 41.5504 66.0038 40.5322 65.7065 39.7095C65.4092 38.9124 64.993 38.2902 64.4479 37.7965C63.8533 37.2771 63.1893 36.9223 62.4114 36.7217C61.569 36.5006 60.6077 36.3875 59.5721 36.3772H59.4432C58.5563 36.3772 57.6594 36.4749 56.7774 36.6549C55.9746 36.8451 55.2809 37.1743 54.7259 37.6422C54.1611 38.1205 53.7151 38.7838 53.393 39.6272C53.061 40.4808 52.8926 41.5761 52.8826 42.98V43.7102C52.8727 44.6718 52.1146 45.4483 51.188 45.4483C50.2614 45.4381 49.5132 44.6513 49.5132 43.6897L49.5231 42.7383C49.5429 39.6735 50.4001 37.3337 52.065 35.7755C53.7201 34.2277 56.2274 33.4409 59.5027 33.4409H59.6068L59.6712 33.4203H59.7158C62.7979 33.4409 65.2209 34.2174 66.9156 35.7241C68.6449 37.2308 69.517 39.5449 69.4972 42.5789L69.4873 43.8182L69.4922 43.8285Z"
                fill="#043B3B"
              />
              <path
                d="M22.2671 0.108584L22.2126 8.87634L12.8721 13.2114H12.8672L12.9465 0.046875L22.2671 0.108584Z"
                fill="#043B3B"
              />
              <path
                d="M90.5 64.7328C90.5 65.391 90.173 66.0029 89.6477 66.3578C81.7988 71.6133 73.1273 75.5678 64.0347 77.8047C58.029 79.2806 51.7311 80.0108 45.4034 80.0005C39.0757 79.9234 32.7827 79.1006 26.8018 77.5476C17.7389 75.1872 9.11697 71.1145 1.33742 65.751C0.807218 65.391 0.5 64.7739 0.5 64.1105C0.50991 62.5421 2.21447 61.6268 3.46317 62.5267L4.66726 63.4009C16.8222 72.1841 31.0186 76.514 45.4182 76.6322C59.8178 76.7145 74.0688 72.58 86.3377 63.9614L87.5517 63.1026C88.8103 62.2182 90.505 63.1592 90.495 64.7276L90.5 64.7328Z"
                fill="#043B3B"
              />
            </g>
            <defs>
              <clipPath id="clip0_7692_4118">
                <rect width="90" height="80" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
        ),
      },
    ],
  },
  {
    title: "The Draw",
    content: [
      "All tickets purchased before the close of the Porsche Bonus Draw at midnight September 30, as well as eligible postal entries, will also be entered into the £4m Surrey Dream Home Draw.",
      "The winner of each competition will be drawn the Friday following the close date. All draws are independently conducted by Civica.",
    ],
  },
];

export {
  singlePrizeData,
  doublePrizeData,
  faqs,
  faqsImages,
  howItWorksItems,
  simpleGalleryData,
  dreamDrawAccordion,
  dreamDrawFeatures,
  heroGalleryImages,
  heroInfoData,
};
